import {
  createContext,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from 'react';

type Props = {
  children: ReactNode;
};

type Notification = {
  message?: ReactNode;
};

export type NotificationContextType = {
  notification?: Notification;
  showNotification: (message: Notification) => void;
  removeNotification: () => void;
};

export const NotificationContext = createContext<NotificationContextType>(
  {} as NotificationContextType,
);

export function NotificationProvider({ children }: Props): React.JSX.Element {
  const [notification, setNotification] = useState<Notification>();

  const showNotification = useCallback((message: Notification = {}) => {
    setNotification(message);
  }, []);

  const removeNotification = useCallback(() => {
    setNotification(undefined);
  }, []);

  const notificationContextValue = useMemo(
    () => ({
      notification,
      showNotification,
      removeNotification,
    }),
    [notification, showNotification, removeNotification],
  );
  return (
    <NotificationContext.Provider value={notificationContextValue}>
      {children}
    </NotificationContext.Provider>
  );
}
